import { getSalesforceImportSummary } from '@api';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const importsSalesforceSummaryGetSlice = createGetAsyncSlice({
	name: 'ImportsSalesforceSummary',
	receive: true,
	request: true,
	requestHandler: getSalesforceImportSummary,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
